export const COMPONENTS_TAB_KEY = 'components';

export const DEFAULT_TAB_INDEX = 0;

export const HEALTH_TAB_KEY = 'health';

export const SERVICE_LOG_TAB_KEY = 'serviceLog';

export const TAB_KEYS = ['health', 'components', 'serviceLog'] as const;

export const TEST_ID = 'droneDetailsDrawer';
